import React from "react";
import { Image } from "@wss/image";
import { Image as ImageModel } from "~/common/MediaViewerV2/model";
import { TransformComponent } from "react-zoom-pan-pinch";

interface ImageGalleryRendererProps {
  image: ImageModel;
  index: number;
  handleOverlayImageChange: (
    image: React.MouseEvent<HTMLAnchorElement>,
  ) => void;
}

const ImageGalleryRenderer = ({
  image,
  index,
  handleOverlayImageChange,
}: ImageGalleryRendererProps) => {
  return (
    <TransformComponent
      wrapperStyle={{
        overflow: "visible",
        width: "auto",
        height: "100%",
      }}
      contentStyle={{
        width: "auto",
        height: "100%",
        maxHeight: "100vh",
      }}
    >
      <a
        href={`#modal-image-${index}`}
        className="
        border-gray-200
        border-solid
        border
        box-border
        h-20
        p-1
        no-underline
        w-20
        md:hover:outline
      "
        onClick={(e) => {
          handleOverlayImageChange(e);
        }}
      >
        <Image
          width={1}
          height={1}
          className="w-full h-auto"
          src={`//cdnimg.webstaurantstore.com${image.thumbnail}`}
          alt={image.alternateText}
        />
      </a>
    </TransformComponent>
  );
};

export default ImageGalleryRenderer;
